<template>
  <div id="product" class="product bg-light">
    <DetailInfo class="main"
      :data="detailData"
      :loading.sync="loading"
      :is-favorite="isFavorite"
			:is-open-shop="isOpenShop"
			:is-in-shop="isInShop"
      @share="handleShareShopProduct"
      @favorite="onToggleFavorite"
      @join="onJoinShop"
    />
    <div class="main-width j_product-detail" ref="containerRef">
      <div class="product__container">
        <div class="flex-1" ref="leftContent">
          <!-- <div class="main"> -->
          <div class="scroll-nav-wraper z-10 sticky" :style="{
            top: 'var(--app-header-height)'
          }">
            <!-- <VSticky :offsetTop="appHeaderHeight" @change="isFixedScrollNav = $event"> -->
              <div class="scroll-nav-affix" :class="[{ 'scroll-nav-affix-fixed': isFixedScrollNav }]" ref="scrollNavRef">
                <scroll-active class="scroll-nav" highlight-first-item tag="ul" :offset="offsetTop">
                  <li v-if="isApiCruise" class="scroll-nav-item scrollactive-item is-active"
                    data-section-selector=".product-info">
                    产品信息
                  </li>
                  <li v-if="isApiCruise" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-cruise1">
                    邮轮信息
                  </li>

                  <li v-if="!isApiCruise && detailData.features" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-features">
                    产品特色
                  </li>
                  <li v-if="!isApiCruise && detailData.tour.length" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-tours">
                    行程介绍
                  </li>
                  <li v-if="
                  detailData.fee_description.include ||
                    detailData.fee_description.not_include
                    " class="scroll-nav-item scrollactive-item" data-section-selector=".product-fee">
                    费用说明
                  </li>
                  <li v-if="hasVisa" class="scroll-nav-item scrollactive-item" data-section-selector=".product-visa">
                    签证所需材料
                  </li>
                  <li v-if="detailData.booking_notice" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-booking-notice">
                    预订须知
                  </li>
                  <li v-if="detailData.cancel_policy" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-cancel">
                    取消政策
                  </li>
                  <li v-if="detailData.tip" class="scroll-nav-item scrollactive-item"
                    data-section-selector=".product-tips">
                    温馨提示
                  </li>
                </scroll-active>
                <div class="scroll-nav__material" @click="openMaterrialDiaog" v-if="detailData.exists_material">
                  <el-image class="scroll-nav__material__icon" fit="contain"
                    src="@/assets/img/product/icon_product_material.png"></el-image>
                  <span>营销素材</span>
                  <i class="ficon ficon-arrow-right"></i>
                </div>
              </div>
            <!-- </VSticky> -->
          </div>
          <transition-group tag="div" enter-active-class="animate__animated animate__fadeIn">
            <div key="info" v-if="isApiCruise && detailData.tour" class="main product-info">
              <div class="main-body">
                <h3 class="main-title">产品信息</h3>
                <!--停靠港口-->
                <div class="port-table mt-2.5">
                  <el-table :data="detailData.tour">
                    <el-table-column label="天" width="80px" prop="sort">
                      <template #default="{ row }">{{
                        row.sort < 10 ? "0" + row.sort : row.sort }} </template>
                    </el-table-column>
                    <el-table-column label="港口" prop="port">
                      <template #default="{ row }">
                        <p v-for="(rowItem, index) in row.port" :key="index" class="row_p">
                          <img :src="rowItem.flag" class="national_flag" v-if="!!rowItem.flag" />
                          <!-- <img src="@/assets/img/product/product_cruise.png" class="national_flag1" v-if="!rowItem.flag&&rowItem.port ==='海上巡航'" /> -->
                          <span>{{ rowItem.port }}</span>
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column label="抵港" prop="arrival_time">
                      <template #default="{ row }">{{
                        row.arrival_time | isEmptyString
                      }}
                      </template>
                    </el-table-column>
                    <el-table-column label="离港" prop="leave_time">
                      <template #default="{ row }">{{
                        row.leave_time | isEmptyString
                      }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <!--邮轮信息-->
            <div key="cruise" v-if="isApiCruise" class="main product-cruise1">
              <div class="main-body">
                <div class="main-title">邮轮信息</div>
                <div class="product-cruise">
                  <div class="product-cruise-information">
                    <h3 class="product-cruise-information__title">
                      {{ detailData.cruises_info.title }}
                    </h3>
                    <p class="product-cruise-information__content">
                      {{ detailData.cruises_info.intro }}
                    </p>
                    <a :href="`/company/cruise/${detailData.cruises_info.id}`" target="_blank"
                      class="product-cruise-information__action">查看详情></a>
                    <img src="@/assets/img/product/product-cruise.png" class="cruise__bg" />
                  </div>
                  <div class="product-cruise-carousel">
                    <el-carousel height="256px" indicator-position="outside">
                      <el-carousel-item v-for="(item, i) in detailData.cruises_info.images" :key="i">
                        <img :src="item" class="cruise_image" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
              </div>
            </div>

            <div key="features" v-if="!isApiCruise && detailData.features" class="main product-features">
              <div class="main-body">
                <h3 class="main-title">产品特色</h3>
                <div class="product-features-content" v-if="detailData.features">
                  <!-- {{ detailData.features }} -->
                  <div :class="[featureHeight > 400 && !showMoreFeature ? 'h-100 overflow-hidden' : '']">
                    <div ref="featureRef">
                    <editor-content normal :content="detailData.features" />
                  </div>
                  </div>
                  <div class="product-fetures-btn mx-auto" v-if="!showMoreFeature && featureHeight >= 400"
                    @click="showMoreFeature = true">
                    <span>了解更多</span>
                    <i class="ficon ficon-arrow-bottom"></i>
                  </div>
                </div>
                <!-- <div class="product-fetures-image" :class="{ 'product-fetures-image--active': visibleFeatureImg }" v-else>
                  <div class="product-fetures-image__wrapper">
                    <el-image class="fetures-image" fit="cover" :src="item" v-for="(item, nn) in detailData.feature_image" :key="nn" />
                  </div>
                  <div class="product-fetures-btn" v-if="!visibleFeatureImg" @click="visibleFeatureImg = true">
                    了解更多
                    <i class="ficon ficon-arrow-bottom"></i>
                  </div>
                </div> -->
              </div>
            </div>
            <div key="tours" v-if="!isApiCruise && detailData.tour.length" class="main product-tours">
              <div class="main-body">
                <h3 class="main-title">行程介绍</h3>
                <!-- <el-image class="product-trip-image" fit="cover" v-if="detailData.trip_image != ''" :src="detailData.trip_image" /> -->

                <!-- 行程介绍 切换 -->
                <!-- <div class="tourNav">
                <span class="tourNav__item" :class="{ 'tourNav__item--active': index == tourNavCode }"
                  v-for="(tour, index) in detailData.tour" :key="index" @click="tourNavCode = index">DAY{{ index + 1
                  }}</span>
              </div> -->
                <div v-for="(tour, tourIndex) in detailData.tour" :key="tourIndex" class="product-tour">
                  <div class="product-tour-header">
                    <div class="product-tour-day">Day {{ tour.sort }}
                      <span v-if="tour.type == '1'" class="product-boarding-day">(登船日)</span>
                      <span v-if="tour.type == '2'" class="product-boarding-day">(离船日)</span>
                    </div>
                    <h4 class="product-tour-title">{{ tour.title }}</h4>
                  </div>
                  <div class="product-tour-con">
                    <el-row class="product-tour-attr" :style="tourStyle(tour)">
                      <el-col v-if="tour.port && tour.port.length && tour.port[0].port" class="attr common icon_flex" :span="24">
                        <el-image style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_port.png" fit="cover"></el-image>
                        停靠港口：
                        <span v-for="(tourIem, tIndex) in tour.port" :key="tIndex">{{
                          tourIem.port
                        }}<span v-if="tIndex !== tour.port.length - 1">、</span></span>
                      </el-col>
                      <el-col class="attr common" :span="24">
                        <el-image v-if="tour.arrival_time || tour.leave_time" style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_time.png" fit="cover"></el-image>
                        <span v-if="tour.arrival_time" class="icon_flex">
                          抵港时间：{{ tour.arrival_time }}
                        </span>
                        <span v-if="tour.leave_time"><span class="line" v-if="tour.arrival_time && tour.leave_time">|</span>离港时间：{{ tour.leave_time }}</span>
                      </el-col>
                      <!-- <el-col v-if="tour.leave_time" class="attr" :span="6">离港时间：{{ tour.leave_time }}</el-col> -->
                      <el-col class="attr common icon_flex" :span="24" v-if="tour.check">
                        <el-image style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_check_in.png" fit="cover"></el-image>
                        入住：{{ tour.check }}
                      </el-col>
                      <el-col class="attr common icon_flex" :span="24">
                        <el-image v-if="tour.dining_info.breakfast || tour.dining_info.lunch || tour.dining_info.dinner" style="width: 16px; height: 16px; margin-right: 12px" src="~@/assets/img/product/icon_food.png" fit="cover"></el-image>
                        <span v-if="tour.dining_info.breakfast">
                          早餐：{{ tour.dining_info.breakfast }}
                        </span>
                        <span v-if="tour.dining_info.lunch">
                          <span class="line" v-if="tour.dining_info.breakfast">|</span>
                          午餐：{{ tour.dining_info.lunch }}
                        </span>
                        <span v-if="tour.dining_info.dinner">
                          <span class="line" v-if="tour.dining_info.lunch || tour.dining_info.breakfast">|</span>
                          晚餐：{{ tour.dining_info.dinner }}
                        </span>
                      </el-col>
                      <!-- <el-col class="attr" :span="24" v-if="tour.dining_info.lunch">
                        午餐：{{ tour.dining_info.lunch }}
                      </el-col>
                      <el-col class="attr" :span="24" v-if="tour.dining_info.dinner">晚餐：{{ tour.dining_info.dinner }}
                      </el-col> -->
                    </el-row>
                    <div class="product-tour-desc" v-if="tour.desc" v-html="tour.desc"></div>
                    <el-row class="product-tour-imgs" :gutter="20" v-if="tour.images.length">
                      <el-col v-for="(img, index) in tour.images" :key="index" class="product-tour-img" :span="8">
                        <el-image class="img" fit="cover" :src="img.path_thumb"
                          @click="showDetailImg(tourIndex, index)" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>

            <!-- 费用说明 -->
            <div key="fee_description" v-if="
            detailData.fee_description.include || detailData.fee_description.not_include
              " class="main product-fee">
              <div class="main-body">
                <div class="main-title">费用说明</div>
                <template v-if="detailData.fee_description.include">
                  <div class="product-fee-subtitle">费用包含</div>
                  <div class="product-fee-content">
                    <pre class="whitespace-pre-wrap">{{ detailData.fee_description.include }}
                  </pre>
                  </div>
                </template>
                <template v-if="detailData.fee_description.not_include">
                  <div class="product-fee-subtitle">费用不含</div>
                  <div class="product-fee-content">
                    <pre class="whitespace-pre-wrap">{{ detailData.fee_description.not_include }}
                  </pre>
                  </div>
                </template>
              </div>
            </div>

            <!-- 签证所需材料 -->
            <div key="visa" v-if="hasVisa" class="main product-visa">
              <div class="main-body">
                <div class="main-title">签证所需材料</div>
                <div class="product-visa-content">
                  <p class="product-visa-desc">{{ detailData.visa.desc }}</p>
                  <div class="product-visa-files">
                    <a v-for="(file, index) in detailData.visa.files" :key="index" :href="file.path">{{ file.name }}</a>
                  </div>
                  <div class="product-visa-images">
                    <el-image class="img" v-for="(img, index) in detailData.visa.images" :key="index" fit="cover"
                      :src="img" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 预订须知 -->
            <div key="booking-notice" v-if="detailData.booking_notice" class="main product-booking-notice">
              <div class="main-body">
                <div class="main-title">预订须知</div>
                <div class="product-booking-notice-content">
                  {{ detailData.booking_notice }}
                </div>
              </div>
            </div>

            <!-- 取消政策 -->
            <div key="product-cancel" v-if="detailData.cancel_policy" class="main product-cancel">
              <div class="main-body">
                <div class="main-title">取消政策</div>
                <div class="product-cancel-content">{{ detailData.cancel_policy }}</div>
              </div>
            </div>

            <!-- 温馨提示 -->
            <div key="product-tips" v-if="detailData.tip" class="main product-tips">
              <div class="main-body">
                <div class="main-title">温馨提示</div>
                <div class="product-tips-content">{{ detailData.tip }}</div>
              </div>
            </div>
          </transition-group>
        </div>

        <div class="product__container__right" ref="rightBoxRef">
          <!-- <v-affix class="fixed" relative-element-selector=".j_product-detail"
            :offset="{ top: appHeaderHeight + 12, bottom: 0 }" :scroll-affix="false" @affix="affixRightPannel = true"
            @affixtop="affixRightPannel = false"> -->
            <div class="sticky" :style="{
              top: 'calc(var(--app-header-height) + 12px)'
            }">
              <CruiseRightPannel :affixd="affixRightPannel" :data="detailData" :voyageData="voyageData"
              :stockData="stockData" />
            </div>
          <!-- </v-affix> -->
        </div>
      </div>
    </div>
    <!-- <v-loading :active="loading"></v-loading> -->
    <!-- S 相关产品推荐 -->
    <ProductRecommond :similar="detailData.similar" />


    <ProductDetailTools v-if="detailData.status !== 0" :is-favorite="isFavorite" :is-open-shop="isOpenShop"
      :is-in-shop="isInShop" @share="handleShareShopProduct" @favorite="onToggleFavorite" @join="onJoinShop" :url="detailData.mini_code" />
    <!--分享店铺产品二维码-->
    <share-shop-product ref="shareShopProductRef"></share-shop-product>
    <!-- <DetailTourImgDIalog ref="refDetailTourImgDIalog"/> -->
    <product-material ref="productMaterialRef" />
  </div>
</template>

<script>
// api
import {
  getProductDetailById,
  getProductDateById,
  getProductStock
} from "~/services/product";
import { getBookingInfoByNo } from "~/services/order";
import { useElementSize, useElementBounding } from "@vueuse/core";

// components
import DetailInfo from "@/views/product/DetailInfo.vue";
import DetailVoyage from "@/views/product/DetailVoyage";
import DetailBooking from "@/views/product/DetailBooking";
import ScrollActive from "@/components/ScrollActive";
import VAffix from "@/components/VAffix";
import VSticky from '~/components/VSticky/index.vue'

import CruiseRightPannel from "@/views/product/CruiseRightPannel.vue";
import ProductRecommond from "@/views/product/ProductRecommond.vue";
import DetailTourImgDIalog from "@/views/product/DetailTourImgDIalog.vue";
import EditorContent from "~/components/Ckeditor/EditorContent.vue";

import ProductDetailTools from '~/views/product/ProductDetailTools.vue'
import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";
import ProductMaterial from '@/components/product/product-material.vue'

// helpers
import {
  useFetch,
  defineComponent,
  ref,
  computed,
  useRoute,
  useMeta,
  getCurrentInstance,
  useContext,
  watchEffect
} from "@nuxtjs/composition-api";

import useLayout from '~/composables/useLayout'
import useProductFavorite from '~/views/product/composables/useProductFavorite';
import useProductJoinShop from '~/views/product/composables/useProductJoinShop';



import { groupBy, isEmpty } from "@/utils/helpers";

import {
  REQUEST_CODES,
  CRUISE_PRODUCT_TYPE,
  CRUISE_CLASS
} from "@/constants/const-http";

// import { createNamespacedHelpers } from "vuex";
// let { mapGetters } = createNamespacedHelpers("product/booking");

function useVoyage() {
  const voyageData = ref([]);
  const currentMonth = ref("");
  const currentVoyage = ref({
    id: "",
    installment_conf: []
  });

  // const {fetch} = useFetch( async () => {

  // })
  const normalizesVoyageDataByMonth = computed(() => {
    return groupBy(voyageData.value, (voyage) => {
      // let [year, month] =
      return voyage.date.split("-").slice(0, 2).join("-");
    });
  });

  const monthNavs = computed(() => {
    return Object.keys(normalizesVoyageDataByMonth.value).reduce(
      (result, month) => {
        let [Y, M] = month.split("-");
        result[month] = `${Y}年${M}月`;
        return result;
      },
      {}
    );
  });

  const selectedVoyages = computed(() => {
    if (!currentMonth.value) return [];
    return normalizesVoyageDataByMonth.value[currentMonth.value];
  });

  function setCurrentVoyage(data = {}) {
    currentVoyage.value = data;
  }

  function setCurrentMonth(month) {
    currentMonth.value = month;
  }

  return {
    voyageData,
    currentVoyage,
    normalizesVoyageDataByMonth,
    selectedVoyages,
    monthNavs,
    currentMonth,
    setCurrentMonth,
    setCurrentVoyage
  };
}

export default defineComponent({
  name: "ProductDetail",
  layout: "Main",
  auth: false,
  components: {
    DetailInfo,
    DetailVoyage,
    DetailBooking,
    ScrollActive,
    VAffix,
    VSticky,
    CruiseRightPannel,
    ProductRecommond,
    DetailTourImgDIalog,
    EditorContent,
    ProductDetailTools,
    ShareShopProduct,
    ProductMaterial
  },
  // props: {
  //   productNo: {
  //     // required: true,
  //     type: String,
  //     default: "",
  //   },
  // },
  head: {},
  setup(props) {
    const { proxy: _this } = getCurrentInstance();
    const {store} = useContext();
    const route = useRoute();
    const {
      voyageData,
      currentVoyage,
      normalizesVoyageDataByMonth,
      selectedVoyages,
      monthNavs,
      currentMonth,
      setCurrentMonth,
      setCurrentVoyage
    } = useVoyage(props);

    const detailData = ref({
      tour: [],
      cruises_info: {},
      features: '',
      cruise_product_type: 1,
      fee_description: {
        include: "",
        not_include: ""
      },
      visa: {
        desc: "",
        images: [],
        files: []
      },
      dates: {
        cabins: [],
        dates: []
      },
      similar: [], // 推荐产品
      mini_code: "" // 产品二维码
    });
    const productNo = computed(() => route.value.params.productNo)
    const getData = async () => {
      let { code, data, msg } = await getProductDetailById({
        product_no: productNo.value
      });
    }
    getData()
    useFetch(async () => {
      let { code, data, msg } = await getProductDetailById({
        product_no: productNo.value
      });
      // this.isLoaded = true;
      // this.loading = false
      if (code !== REQUEST_CODES.ERROR_OK) {
        throw new Error(msg);
      }
      detailData.value = Object.freeze(data);

      isFavorite.value = !!data.is_favorite;
      isInShop.value = !!data.in_shop;
    });
    const title = computed(() => `${detailData.value.title} ${detailData.value.departure}出发 ${detailData.value.dates.dates.length}个团期可定`);

    useMeta(() => ({
      title: title.value,
      meta: [ {
          name: "description",
          hid: "description",
          // 【上船吧】（www.shangchuanba.com），产品特色（例*高端品牌 Club Med始于1950年，是世界上最早的高端休闲品牌，Club Med不仅是品质的象征，确保您的假期安心舒适，也是您身份的彰显——尊贵体面。其独特的“一价全包”、休闲运动度假村形式、特别的G.O文化等，使其成为独…）
          content: `【上船吧】（www.shangchuanba.com），${detailData.value.features}`
        },
        {
          name: "keywords",
          hid: "keywords",
          // content: state.value.cruises.map((cruise) => cruise.name),
          content:
            "上船吧，分销平台，产品特色，行程介绍，费用说明，预订须知，取消政策，温馨提示，费用包含，费用不含，"
        }]
    }));

    // ======================= 收藏 =======================
    const { isFavorite, onToggleFavorite } = useProductFavorite(productNo)

    // ======================= 分享 =======================
    const shareShopProductRef = ref(null);
    const handleShareShopProduct = () => {
      shareShopProductRef.value.handleShareShopPrdouct({ title: detailData.value.title, product_no: productNo.value });
    }
    const isOpenShop = computed(() => store.getters.isOpenShop)
    const { isInShop, onJoinShop } = useProductJoinShop(productNo);



    const leftContent = ref();
    const { width } = useElementSize(leftContent);

    const showMoreFeature = ref(false);

    const featureRef = ref(null)
    const { height: featureHeight } = useElementSize(featureRef);

    // ======================= sticky =======================
    const { headerSize } = useLayout();
    const scrollNavRef = ref();
    const { height: scrollNavHeight } = useElementSize(scrollNavRef)
    const offsetTop = computed(() => headerSize.height + scrollNavHeight.value);
    // const appHeaderHeight = computed(() => headerSize.height);

    // 主体
    const containerRef = ref();
    const {
      top
    } = useElementBounding(containerRef);

    const affixRightPannel = computed(() => top.value <= headerSize.height + 12)
    const isFixedScrollNav = computed(() =>  top.value <= headerSize.height);

    watchEffect(() => {
      console.log(top.value)
    })
    return {
      containerRef,
      detailData,
      productNo,
      title,
      voyageData,
      currentVoyage,
      normalizesVoyageDataByMonth,
      selectedVoyages,
      monthNavs,
      currentMonth,
      setCurrentMonth,
      setCurrentVoyage,
      leftContWidth: width,
      leftContent,
      showMoreFeature,
      featureRef,
      featureHeight,

      scrollNavRef,
      isFixedScrollNav,
      offsetTop,
      // appHeaderHeight,
      affixRightPannel,

      shareShopProductRef,
      handleShareShopProduct,

      isFavorite,
      onToggleFavorite,


      isOpenShop,
      isInShop,
      onJoinShop,
    };
  },
  data() {
    return {
      voyageLoaded: false,
      voyageLoading: true,
      loading: false,
      isLoaded: false,
      stockData: [],
      bookingType: "bulk",
      bookingData: {},
      tourNavCode: 0,
      // affixRightPannel: false, // 右侧吸顶了
      visibleFeatureImg: false
    };
  },
  computed: {
    hasVisa() {
      return Object.values(this.detailData.visa).some((val) => !isEmpty(val));
    },
    bookingNo() {
      return this.$route.query.booking_no;
    },
    auth() {
      return this.$auth.$state;
    },
    loggedIn() {
      return this.auth.loggedIn;
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
    isApiCruise() {
      return (
        this.detailData.class === CRUISE_PRODUCT_TYPE.API &&
        [
          CRUISE_CLASS.OVERSEAS,
          CRUISE_CLASS.OCEAN,
          CRUISE_CLASS.POLAR
        ].includes(this.detailData.class_id)
      );
    }
  },
  filters: {
    isEmptyString(value) {
      return !value ? "-" : value;
    }
  },
  async mounted() {
    console.log("mountedmountedmounted1");
    if (this.bookingNo) {
      await this.fetchBookingData(this.bookingNo);
    }
    this.fetchVoyageData();
  },
  methods: {
    async fetchBookingData(booking_no) {
      let { code, data } = await getBookingInfoByNo({ booking_no });
      console.log(data, "bookingData");
      if (code !== 10000) {
        return {};
      }
      this.bookingData = data;
      this.bookingType = data.params.sale_type == 1 ? "cut" : "bulk";
    },
    async fetchVoyageData() {
      this.voyageLoading = true;
      let { code, data, msg } = await getProductDateById({
        product_no: this.productNo
      });
      this.voyageLoading = false;

      if (code !== REQUEST_CODES.ERROR_OK) {
        throw new Error(msg);
      }
      this.voyageData = data;

      await this.$nextTick();

      if (isEmpty(this.bookingData)) {
        this.currentMonth = Object.keys(this.monthNavs)[0];
        await this.$nextTick();

        if (this.selectedVoyages.length > 0 && !this.currentVoyage.id) {
          // this.currentVoyage = this.selectedVoyages[0];
          let currentVoyage = this.selectedVoyages[0] || {};
          this.currentVoyage = currentVoyage;
          // this.currentVoyage ;
          await this.fetchProductStock({
            spd_id: currentVoyage.id,
            product_no: this.productNo
          });
        }
      } else {
        let currentVoyage = this.voyageData.find(
          (item) => item.date === this.bookingData.params.date
        );
        let currentMonth = currentVoyage.date.split("-").slice(0, 2).join("-");
        this.currentMonth = currentMonth;
        this.currentVoyage = currentVoyage;
        this.fetchProductStock({
          spd_id: currentVoyage.id,
          product_no: this.productNo
        });
      }
      this.voyageLoading = false;
      this.voyageLoaded = true;
    },

    async fetchProductStock(params) {
      let { code, data, msg } = await getProductStock(params);
      if (code !== REQUEST_CODES.ERROR_OK) {
        return;
      }
      console.log("");
      this.stockData = data.list;
    },

    onVoyageUpdate(voyage) {
      this.fetchProductStock({
        spd_id: voyage.id,
        product_no: this.productNo
      });
    },
    openMaterrialDiaog() {
      this.$refs.productMaterialRef.setData({
        product_no: this.productNo
      })
      // this.$createMaterialDialog({
      //   $props: {
      //     productNo: this.productNo,
      //     exists_file: this.detailData.exists_file,
      //     exists_image: this.detailData.exists_image,
      //     exists_video: this.detailData.exists_video
      //   }
      // }).show();
    },
    showDetailImg(toutIndex, imgIndex) {
      console.log(toutIndex, imgIndex);
      const dialog = this.$createDetailTourImgDIalog({
        $props: {
          imgs: this.detailData.tour[toutIndex].images,
          activeIndex: imgIndex
        },
        onClose() {
          dialog.remove();
        }
      }).show();
    },
    tourStyle(tour) {
      if (tour) {
        if ((tour.port && tour.port.length && tour.port[0].port) || tour.arrival_time || tour.leave_time || tour.check || tour.dining_info.breakfast || tour.dining_info.lunch || tour.dining_info.dinner) {
          return {
            marginBottom: '20px'
          }
        }
      }
      return {}
    }
  }
});
</script>

<style lang="scss" scoped>
::v-deep .main {
  margin-bottom: 12px;
}
::v-deep .main-body {
  background: #fff;
  padding: 20px;
}
::v-deep .main-title {
  font-size: 20px;
  line-height: 20px;
  color: $important-text-color;
  font-weight: 500;
  position: relative;
}
.fixed {
  z-index: 10;
}
.fixed.affix {
  border-bottom-width: 1px;
}
.scroll-nav-affix-fixed {
  border-bottom-width: 1px;
}
.scroll-nav-wraper {
  height: 66px;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  margin-bottom: 0.75rem;
}
.scroll-nav {
  display: flex;
  background: #fff;
  color: #495057;
}
.scroll-nav-item {
  font-weight: 500;
  padding: 20px 0;
  margin: 0 20px;
  background: transparent;
  cursor: pointer;
  border-radius: $border-radius-base;
  font-size: 16px;
  position: relative;
}
.scroll-nav-item.is-active {
  color: #1F2129;
  border-bottom: 3px solid currentColor;
}
.scroll-nav__material {
  position: absolute;
  display: flex;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  cursor: pointer;
  user-select: none;
}
.scroll-nav__material__icon {
  width: 39px;
  height: 31px;
  margin-right: 5px;
}
.scroll-nav__material >span {
  color: #495057;
  font-size: 14px;
}
.scroll-nav__material .ficon {
  color: #979797;
}
::v-deep .product {
  position: relative;
}
::v-deep .product-features-content, ::v-deep .product-visa-content, ::v-deep .product-booking-notice-content, ::v-deep .product-cancel-content, ::v-deep .product-tips-content {
  margin-top: 18px;
  white-space: pre-line;
  line-height: 24px;
  color: $secondary-text-color;
}
::v-deep .product__container {
  display: flex;
}
::v-deep .product__container__right {
  width: 346px;
  margin-left: 16px;
  flex-shrink: 0;
}
::v-deep .product-fetures-image {
  position: relative;
  margin-top: 18px;
  font-size: 0;
  padding-bottom: 50px;
}
::v-deep .product-fetures-image__wrapper {
  padding-bottom: 100px;
  max-height: 500px;
  overflow: hidden;
  position: relative;
}
::v-deep .product-fetures-image--active {
  padding-bottom: 0;
}
::v-deep .product-fetures-image--active .product-fetures-image__wrapper {
  padding-bottom: 0;
  max-height: none;
  overflow: visible;
}
::v-deep .product-fetures-image .fetures-image {
  width: 100%;
}
::v-deep .product-fetures-btn {
  width: 112px;
  height: 36px;
  bottom: 0;
  left: 50%;
  border-radius: 6px;
  color: $color-primary;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 1;
  cursor: pointer;
  user-select: none;
}
::v-deep .product-fetures-btn .ficon {
  margin-left: 5px;
}
::v-deep .product-trip-image {
  width: 100%;
  margin-top: 18px;
}
::v-deep .product-tour {
  margin-top: 18px;
}
::v-deep .product-tour-header {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 500;
}
::v-deep .product-tour-day, ::v-deep .product-tour-title {
  font-weight: 500;
  font-size: 18px;
}
::v-deep .product-tour-day {
  padding: 9px 0;
  text-align: center;
  color: #212529;
  font-weight: 500;
  margin-right: 10px;
}
::v-deep .product-tour-day::after {
  content: "";
  width: 1px;
  height: 1em;
  background: #d8d8d8;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
::v-deep .product-tour-title {
  padding: 9px 0;
  color: $important-text-color;
}
::v-deep .product-tour-con {
  margin-top: 10px;
  padding-bottom: 15px;
}
::v-deep .product-tour-con .c-attr {
  margin-top: 12px;
}
::v-deep .product-tour-con .c-attr .attr {
  margin-bottom: 4px;
}
::v-deep .product-tour-con .product-tour-desc {
  white-space: pre-line;
  font-size: 15px;
  line-height: 1.5;
  color: $color-grey-2;
}
::v-deep .product-tour-imgs {
  margin-top: 18px;
}
::v-deep .product-tour-img {
  height: 166px;
  margin: 10px 0;
}
::v-deep .product-tour-img .img {
  width: 100%;
  height: 100%;
}
::v-deep .product-fee-subtitle {
  margin-top: 12px;
  font-weight: bold;
  color: $secondary-text-color;
}
::v-deep .product-fee-content {
  line-height: 24px;
  margin-top: 5px;
}
::v-deep .product-visa-files {
  margin-top: 17px;
}
::v-deep .product-visa-files a {
  color: $color-blue;
  margin-left: 27px;
}
::v-deep .product-visa-files a:first-child {
  margin-left: 0;
}
::v-deep .product-visa-images {
  margin-top: 27px;
}
::v-deep .product-visa-images .img {
  width: 170px;
  height: 100px;
  margin-left: 16px;
}
::v-deep .product-visa-images .img:first-child {
  margin-left: 0;
}
::v-deep .product-cruise {
  width: 100%;
  height: 256px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
::v-deep .product-cruise-information {
  width: 298px;
  background: linear-gradient(270deg, #fcfcfc 0%, #eaf8ff 100%);
  padding: 14px 20px;
  box-sizing: border-box;
  position: relative;
}
::v-deep .product-cruise-information__title {
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: $color-grey-2;
}
::v-deep .product-cruise-information__content {
  font-size: 14px;
  font-weight: 400;
  color: #868e96;
  line-height: 21px;
  text-align: justify;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  position: relative;
  z-index: 2;
}
::v-deep .product-cruise-information__action {
  font-size: 14px;
  font-weight: 400;
  color: #0d3146;
  margin-top: 10px;
  display: block;
}
::v-deep .product-cruise-information .cruise__bg {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 126px;
  height: 83px;
}
::v-deep .product-cruise-carousel {
  flex: 1;
}
::v-deep .product-cruise-carousel .el-carousel__indicators {
  position: absolute;
}
::v-deep .product-cruise-carousel .el-carousel__indicators--outside {
  bottom: 0px;
  left: auto;
  right: 10px;
}
::v-deep .product-cruise-carousel .el-carousel__indicators .el-carousel__button {
  width: 10px;
  height: 4px;
  background: rgba(43, 43, 54, 0.6);
  border-radius: 2px;
}
::v-deep .product-cruise-carousel .el-carousel__indicators .is-active .el-carousel__button {
  width: 16px;
  background: #fff;
}
::v-deep .product-boarding-day {
  font-size: 16px;
  color: #1F2129;
  font-weight: normal;
  margin-left: 10px;
}
.icon_flex {
  display: flex;
  align-items: center;
}
.line {
  margin: 0 8px;
}
.common {
  display: flex;
  align-items: center;
}
::v-deep .port-table {
  border: 1px solid #edeff5;
}
::v-deep .port-table .el-table .has-gutter .el-table__cell {
  height: 36px;
  line-height: 36px;
  padding: 0;
  box-sizing: border-box;
}
::v-deep .port-table .el-table .cell {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  padding: 0 20px;
}
::v-deep .port-table .el-table .cell .row_p {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
::v-deep .port-table .el-table .cell .national_flag {
  width: 24px;
  display: inline-flex;
  margin-right: 10px;
}
.tourNav {
  display: flex;
  padding: 15px 4px 5px;
  flex-wrap: wrap;
}
.tourNav__item {
  color: #495057;
  font-size: 14px;
  padding: 4px 18px;
  border-radius: 6px;
  background-color: #e9ecef;
  margin-right: 6px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
}
.tourNav__item--active {
  background-color: #f03e3e;
  color: #fff;
}
#product-detail {
  flex: 1;
}
.cruise_image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
